(function () {
    'use strict';

    function closeEventPopup(e) {
        var clickedEvent = e.target.getAttribute('data-animation') === 'false';
        var clickedLeegStukjeInAgenda = e.target.className === 'agenda-dag-uur-division'; //Geeft nieuw invoer popup
        var clickedBinnenPopover = !!$(e.target).parents('.popover').length;
        if (clickedEvent || clickedLeegStukjeInAgenda || clickedBinnenPopover) {
            return;
        }

        var popover = $('[data-original-title]');
        if (popover && popover.popover) {
            popover.popover('hide');
        }
    }


    function closeWerkSchemaPopup(e) {
        var clickedWerkschemaEvent = !!$(e.target).parents('.agenda-event-container').length;
        if (clickedWerkschemaEvent) {
            return;
        }

        var divs = document.querySelectorAll('[ng-controller=WerkschemaEventController]');
        for (var i = 0; i < divs.length; ++i) {
            angular.element(divs[i]).scope().dismissPopover();
        }
    }


    function closeMenu(e) {

        if (!e.target.className || !e.target.className.indexOf) {
            return;
        }
        var clickedOpenMenu = e.target.className.indexOf('navbar-toggle') > -1;
        var clickedDropdownInMenu = e.target.className.indexOf('dropdown-toggle') > -1;
        var clickedZoekenDropdownMenu = e.target.name === 'navbar_zoeken';

        if (clickedOpenMenu || clickedDropdownInMenu || clickedZoekenDropdownMenu) {
            return;
        }

        if (!document.querySelector('.navbar-toggle')) {
            return;
        }
        if (document.querySelector('.navbar-toggle').className.indexOf('collapsed') === -1 &&
            $('.navbar-collapse').is(':visible') && $('.navbar-toggle').is(':visible')) {
            $('.navbar-toggle').trigger('click');
        }
    }


    angular.module('doclr.resources.common', [])
        .directive('datestepper', function () {
            return {
                restrict: 'A',
                templateUrl: '/partials/components/datestepper.html',
                scope: {
                    modus: '=',
                    onDagChanged: '&',
                    dag: '=',
                    minDate: '=',
                    isDisabled: '=',
                    maxDate: '=',
                    pusher: '=',
                    showNextAppointment: '='
                },
                link: function ($scope) {
                    function interval() {
                        return $scope.modus === 'week' ? 'week' : 'day';
                    }

                    function dagBackward() {
                        return moment($scope.dag).subtract(1, interval());
                    }

                    function dagForward() {
                        return moment($scope.dag).add(1, interval());
                    }

                    function setDag(dag) {
                        $scope.dag = dag.format('YYYY-MM-DD');
                        $scope.onDagChanged({dag: $scope.dag});
                    }

                    function getWeekOffset(weeks) {
                        return moment($scope.dag).add(weeks, 'weeks');
                    }

                    function inRange(date) {
                        return !(date.isBefore($scope.minDate, interval()) || date.isAfter($scope.maxDate, interval()));
                    }

                    function vandaag() {
                        return moment();
                    }

                    $scope.naarVandaag = function () {
                        setDag(vandaag());
                    };

                    $scope.isVandaag = function () {
                        return vandaag().isSame($scope.dag, interval());
                    };

                    $scope.back = function () {
                        if ($scope.isBackValid()) {
                            setDag(dagBackward());
                        }
                    };

                    $scope.isBackValid = function () {
                        return !dagBackward().isBefore($scope.minDate, interval());
                    };

                    $scope.forward = function () {
                        if ($scope.isForwardValid()) {
                            setDag(dagForward());
                        }
                    };

                    if (!$scope.pusher) {
                        $scope.$on('keyup:37', $scope.back);
                        $scope.$on('keyup:39', $scope.forward);
                    }

                    $scope.isForwardValid = function () {
                        return !dagForward().isAfter($scope.maxDate, interval());
                    };

                    $scope.weekOffset = function (weeks) {
                        if ($scope.isWeekOffsetValid(weeks)) {
                            setDag(getWeekOffset(weeks));
                        }
                    };

                    $scope.isWeekOffsetValid = function (weeks) {
                        return inRange(getWeekOffset(weeks));
                    };


                }
            };
        })
        .factory('popupCloser', function () {
            return {
                closeEventPopup: closeEventPopup,
                closeWerkSchemaPopup: closeWerkSchemaPopup,
                closeMenu: closeMenu
            }
        });


    $('body').on('click', function (e) {
        closeMenu(e);
        closeEventPopup(e);
        closeWerkSchemaPopup(e);
    });
})();